module.exports = __webpack_public_path__ + "static/media/pied_piper.170f2f6b.png";